import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { CopyScripturesTemplate } from '../../components/Templates';
import { QuickCreateGameMode } from '../../models/DraftStore';
import { useDraftStore } from '../../stores/DraftStore';
import { useSessionStore } from '../../stores/SessionStore';
import { useUserStore } from '../../stores/UserStore';

interface State {
  createType: QuickCreateGameMode | undefined;
}

const CopyScripturesScreen: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigationState = location.state as {
    withBackState: boolean;
  } | null;

  const activeUserId = useSessionStore((store) => store.activeUserId);
  const userAccount = useUserStore((store) =>
    store.getAccount(activeUserId ?? ''),
  );
  const [state, setState] = useState<State>({
    createType: undefined,
  });

  const { mode } = useDraftStore((store) => {
    const _mode = store.getGameMode();

    return { mode: _mode };
  });

  useEffect(() => {
    if (mode) {
      setState((s) => ({ ...s, createType: mode }));
    } else {
      navigate('/create/memory-game/select-type', { replace: true });
    }
  }, [mode, navigate]);

  const onClickBack = useCallback(() => {
    if (navigationState?.withBackState) {
      navigate(-1);
    } else {
      navigate('/create/memory-game/input-content');
    }
    setTimeout(() => {
      document.documentElement.style.scrollBehavior = 'auto'; // instant scroll
      document.body.style.scrollBehavior = 'auto';
      document.documentElement.scrollTop =
        document.documentElement.scrollHeight;
      document.body.scrollTop = document.body.scrollHeight;
    }, 10);
  }, [navigate, navigationState?.withBackState]);

  return (
    <CopyScripturesTemplate
      type={state.createType}
      webBoosterType={userAccount?.settings.webBoosterType}
      onClickBack={onClickBack}
    />
  );
};

export default CopyScripturesScreen;
